<template>
    <tg-dialog
        ref="dialog"
        :title="title"
        v-bind="{ ...$attrs }"
        v-on="$listeners"
        :visible.sync="visible"
        :showIcon="false"
        :showFooter="true"
        :showCancelBtn="true"
        :confirmLabel="confirmLabel"
        :cancelLabel="cancelLabel"
        width="35%"
        @on-confirm="handleConfirm"
        @on-cancel="handleCancel"
        :disableConfirmBtn="checkBoxClear"
        :confirmBtnClass="confirmBtnClass"
        class="tg-member-privilege-bulk-dialog"
    >
        
        <template             >
            <!-- 功能 | 全選 -->
            <el-row
                type="flex"
                justify="start"
                align="middle"
            >
                <span>{{ $t("component.label.markets") }}</span>
                <span class="mb-3">|</span>
                <span
                    class="text-primary clickable"
                    @click="toggleSelectAll()"
                >
                    {{ $t("enum.select_all[" +(selectAll ? 0 : 1) +"]") }}
                </span>
            </el-row>

            <el-row type="flex" justify="start" align="middle">
                <el-checkbox-group v-model="choosed">
                    <template v-for="(item) in marketTypes">
                        <el-checkbox
                            :label="item"
                            :key="item"
                            @change="handleMarketTypeChoose(item)"
                            :style="{width:maxLabelWidth+'px'}"
                        >
                            {{ item == '-1' ? $t('label.other_third_party') : $t("enum.marketType[" + item + "]") }}
                        </el-checkbox>
                    </template>
                </el-checkbox-group>
            </el-row>
        </template>
    </tg-dialog>
</template>

<script>
// import apis from "@/apis";
import TgDialog from "@/components/dialog/TgDialog";

export default {
    inheritAttrs: false,
    components: {
        TgDialog,
    },
    data() {
        return {
            marketTypes: [1, 2, 3, 0, 6, '-1'],
            visible: false,
            selectAll: true,
            response: [],
            choosed: [1, 2, 3, 0, 6, '-1'],
            maxLabelWidth: 0,
        };
    },
    props: {
        marketTypeFilter: Array,
    },
    computed: {
        title() {
            return this.$t("component.btn.marketType_choose");
        },
        confirmLabel() {
            return this.$t("component.btn.confirm");
        },
        cancelLabel() {
            if(this.checkBoxClear){
                return this.$t("component.btn.all");
            }else{
                return this.$t("component.btn.clear");
            }
        },
        selected() {
            return this.choosed;
        },
        checkBoxClear(){
            return this.selected.length == 0;
        },
        confirmBtnClass(){
            if(this.checkBoxClear){
                return [];
            }else{
                return ['confirm'];
            }
        },
    },
    created() {
        let maxWidth = 0;
        this.marketTypes.forEach(item => {
            if((this.$t("enum.marketType["+item + "]").replace(/[\u4E00-\u9FFF]/g,"xx").length)*8 > maxWidth){
                maxWidth = this.$t("enum.marketType["+item + "]").replace(/[\u4E00-\u9FFF]/g,"xx").length*8;
            }
        });
        this.maxLabelWidth = maxWidth+25;

        this.$emit("on-click", this.selected);
    },
    methods: {
        showDialog() {
            this.visible = true;
        },
        handleConfirm() {
            this.$emit("on-click", this.selected);
        },
        toggleSelectAll() {
            // 相反操作
            this.selectAll = !this.selectAll;
            if (this.selectAll) {
                this.choosed = [...this.marketTypes];
            } else {
                this.choosed = [];
            }
        },
        handleCancel(e) {
            e.preventDefault = true;
            this.toggleSelectAll();
            // if(this.selected){
            //     let checkBoxClear = this.checkBoxClear;
            //     Object.keys(this.functional).forEach((category) => {
            //         if(checkBoxClear){
            //             if(this.functional[category].length == 0 && this.third_party_array[category] && this.third_party_array[category].length != 0){
            //                 this.toggleSelectAll(category);
            //             }
            //         }else if(this.functional[category].length > 0){
            //             this.functional[category] = [];
            //             this.selectAll[category] = false;
            //         }
            //     });
            // }else{
            //     Object.keys(this.functional).forEach((category) => {
            //         this.functional[category] = [];
            //         this.selectAll[category] = false;
            //     });
            // }
        },
        handleMarketTypeChoose() {
            this.selectAll = this.marketTypes.length == this.selected.length;
        },
    },
};
</script>
